import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  AvailabilityControllerApi,
  GetProviderSlotsAvailabilityModeEnum,
} from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../utils/utils";

interface Params {
  disabled?: boolean;
  pagination: DGT_Pagination;
  startDate?: string | null;
  endDate?: string | null;
  xTENANTID?: string;
  appointmentType: string;
  providerUuid: string;
  locationUuid?: string;
  availabilityMode?: GetProviderSlotsAvailabilityModeEnum;
}

/**
 * @author Shrinivas Mandhare
 */
export function useSlotList({
  providerUuid,
  pagination,
  startDate,
  endDate,
  xTENANTID,
  appointmentType,
  availabilityMode,
  locationUuid,
  disabled,
}: Params): useBaseContent<any> {
  return useQuery({
    queryKey: [
      "slots-list",
      pagination.pageSize,
      // startDate,
      endDate,
      xTENANTID,
      appointmentType,
      providerUuid,
      availabilityMode,
      locationUuid,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled:
      !disabled &&
      ((!!appointmentType && !!providerUuid) ||
        (!!startDate && startDate !== endDate)),
    retry: (failureCount) => failureCount < 0,
    queryFn: async () => {
      return new AvailabilityControllerApi(getConfigObject())
        .getProviderSlots(
          providerUuid, //providerUuid
          appointmentType, //appointmentType
          pagination.page, //page
          pagination.pageSize, //size
          startDate ?? undefined, // startDate
          endDate ?? undefined, // endDate
          availabilityMode, //availabilityMode
          locationUuid, //
          xTENANTID //xTENANTID
        )
        .then((res) => res?.data);
    },
  });
}
